import { COLORS } from './enum/color';

export default class UserFactory {

    getRandomColor() {
        const randomColor = COLORS[Math.floor(Math.random() * COLORS.length)];

        return randomColor;
    }

    getInitials(fullName) {
    if (!fullName) return '';

    const words = fullName.trim().split(/\s+/);

    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }

    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();

    return firstInitial + lastInitial;
}

}

